/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import '../../../css/ctfResource.css';
import { Button, Table, Input, Pagination, Divider, Dropdown, Menu } from 'antd'
import { SearchOutlined, DownOutlined } from '@ant-design/icons';
import instance from '../../Communal/instance';
import { Alert } from '../../Communal/utility';
import DeteleBox from '../deteleBox';
import Comfirm from '../comfirm';
import { levelList } from '../../../utils/method';
function List() {
    const [search, setsSearch] = useState({
        show: false,
        value: ""
    })
    const [initData, setInitData] = useState(
        {
            data: [],//表格数据
            allCount: 0,//表格数据长度
            hotKeyword: [],//热搜关键词
            resourceNumber: {}//资源数
        }
    )
    const [filter, setFilter] = useState(
        {
            page: 1,
            size: 10,
            search: "",
            classify: [],
            status: [],
            ordering: "",
            username: "",
        }
    )
    const [checkList, setCheckList] = useState([])
    const [classify, setClassify] = useState([]);
    const [userType, setUserType] = useState(0);
    const [userIssue, setIssue] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(
        {
            show: false,
            list: []
        }
    )
    const [comfirmShow, setComfirmShow] = useState({
        visible: false,
        mode: 'knowledge',
        issue: '',
    })
    // 获取热搜词
    useEffect(() => {
        resourceNumber();
        instance.get("/ctf/hot_word/", { params: { type: "knowledge", size: 5 } }).then(data => {
            initData.hotKeyword = data;
            setInitData({ ...initData })
        })
        instance.get("/ctf/classify/?type=10").then(data => {
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    data[i].text = data[i].name;
                    data[i].value = data[i].id
                }
            }
            setClassify(data)
        })
        instance.get("/ctf/user/type/?mode=knowledge").then(data => {
            setUserType(data.user_type);
            setIssue(data.issue);
        })
    }, [])
    // 获取知识列表
    useEffect(() => {
        getKnowledge()
    }, [filter])
    const resourceNumber = () => {
        instance.get("/ctf/sum/", { params: { type: "knowledge" } }).then(data => {
            initData.resourceNumber = data;
            setInitData({ ...initData })
        })
    }
    const getKnowledge = () => {
        instance.get("/knowledge/", { params: filter }).then(data => {
            initData.data = data.results;
            initData.allCount = data.count;
            setInitData({ ...initData })
        })
    }
    //搜索回车事件
    const calAge = (e) => {
        var evt = window.event || e;
        if (evt.keyCode === 13) {
            handelSearch();
        }
    }
    // 点击搜索
    const handelSearch = () => {
        if (search.value !== filter.search) {
            filter.search = search.value;
            filter.page = 1;
            setFilter({ ...filter })
        }
        search.show = true;
        setsSearch({ ...search });
    }
    // 点击搜索框外切换为资源数
    const onClicks = (ev) => {
        var e = ev || window.event; //浏览器兼容性
        var elem = e.target || e.srcElement;
        while (elem) {
            //循环判断至跟节点，防止点击的是div子元素
            if (elem.className === "top") {
                return;
            } else {
                elem = elem.parentNode;
            }
        }
        search.show = false;
        setsSearch({ ...search });
    }
    //导出
    const exportKnowledge = (type) => {

    }
    // 表格有改动时触发
    const handleTableChange = (pagination, filters) => {
        if (filters.classify) {
            filter.classify = filters.classify;
        } else {
            filter.classify = [];
        }
        if (filters.status) {
            filter.status = filters.status;
        } else {
            filter.status = [];
        }
        if (filters.resource_level) {
            filter.level = filters.resource_level;
        } else {
            filter.status = [];
        }
        if (filters.issue) {
            filter.issue = filters.issue;
        } else {
            filter.issue = [];
        }
        filter.page = 1;
        setFilter({ ...filter });
    }
    // 删除操作
    const resourceDelete = (list) => {
        instance.post('/knowledge/deletion/', { "id": list }).then(data => {
            if (filter.page > 1 && (initData.data.length === list.length)) {
                filter.page -= 1;
                setFilter({ ...filter })
            } else {
                // 更新数据
                getKnowledge()
            }
            Alert("success", "删除成功");
            setCheckList([]);
            deleteInfo.list = [];
            deleteInfo.show = false;
            setDeleteInfo({ ...deleteInfo })
            resourceNumber();
        }).catch(err => {
            Alert('warn', err.error)
        })
    }
    const rowSelection = {
        selectedRowKeys: checkList,
        preserveSelectedRowKeys:true,
        onChange: (selectedRowKeys, selectedRows) => {
            deleteInfo.list = selectedRowKeys
            setDeleteInfo({ ...deleteInfo })
            setCheckList(selectedRowKeys)
        }
    }
    const columns = [
        {
            title: '序号',
            key: 'id',
            width: 80,
            fixed: 'left',
            align: 'center',
            // 递增序号
            render: (text, record, index) => (
                <span
                    className="click-href"
                    onClick={() => {
                        window.location.href = "/#/activity/knowledgedetail/" + record.id
                    }}
                >
                    {filter.size * (filter.page - 1) + index + 1}
                </span>
            )
        }, {
            title: '知识编号',
            key: 'number',
            dataIndex: 'number',
            align: 'center',
            width: 200,
            fixed: 'left',
            render: (text, record) => (
                text ? <span
                    className="click-href"
                    onClick={() => {
                        window.location.href = "/#/activity/knowledgedetail/" + record.id
                    }}
                >
                    {text}
                </span>
                    : "暂无编号"
            )
        }, {
            title: '知识名称',
            align: 'center',
            key: 'name',
            dataIndex: 'name',
            width: 250,
            fixed: 'left',
            render: (text, record, index) => {
                return <span
                    className="click-href"
                    onClick={() => {
                        window.location.href = "/#/activity/knowledgedetail/" + record.id
                    }}
                >
                    {text}
                </span>
            }
        }, {
            title: '知识类型',
            key: 'classify',
            dataIndex: 'classify',
            width: 150,
            align: 'center',
            filters: classify,
        }, {
            title: '审核状态',
            key: 'status',
            dataIndex: 'status',
            width: 150,
            align: 'center',
            filters: [
                { text: "待审核", value: "0" },
                { text: "通过", value: "1" },
                { text: "待补充", value: "2" },
                { text: "拒绝", value: "3" }
            ],
            render: (record) => {
                return <span className="audit-status">
                    {
                        record === 0 && "待审核"
                    }
                    {
                        record === 1 && <span className="pass">通过</span>
                    }
                    {
                        record === 2 && <span className="added">待补充</span>
                    }
                    {
                        record === 3 && <span className="denied">拒绝</span>
                    }
                </span>
            },
        }, {
            title: '发布状态',
            key: 'issue',
            dataIndex: 'issue',
            width: 150,
            filterMultiple: false,
            align: 'center',
            filters: [
                { text: "未发布", value: 1 },
                { text: "已发布", value: 2 },
            ],
            render: (record) => {
                return <span className="audit-status">
                    {
                        record === 1 && <span className="added">未发布</span>
                    }
                    {
                        record === 2 && <span className="pass">已发布</span>
                    }
                </span>
            },
        },
        {
            title: '资源等级',
            key: 'resource_level',
            dataIndex: 'resource_level',
            width: 150,
            align: 'center',
            filters: levelList
        }, {
            title: '提交者',
            key: 'username',
            dataIndex: 'username',
            width: 150,
            align: 'center',
            filterDropdown: ({ clearFilters }) => (
                <div className="table-search">
                    <Input
                        placeholder="请输入提交者名称"
                        value={filter.username}
                        onChange={(e) => {
                            filter.username = e.target.value;
                            filter.page = 1;
                            setFilter({ ...filter })
                        }}
                    />
                    <Button
                        type="primary"
                        onClick={() => { clearFilters() }}
                    >
                        确定
                    </Button>
                    <Button onClick={() => {
                        clearFilters();
                        filter.username = "";
                        filter.page = 1;
                        setFilter({ ...filter })
                    }}>取消</Button>
                </div>
            ),
            filterIcon: <SearchOutlined />
        }, {
            title: '提交时间',
            key: 'sub_time',
            dataIndex: 'sub_time',
            width: 200,
            align: 'center',
        }, {
            title: '操作',
            key: 'operate',
            dataIndex: 'operate',
            align: 'center',
            width: userType > 1 ? userIssue ? 260 : 210 : 160,
            fixed: 'right',
            render: (text, record) => {
                return <div>
                    <Button
                        style={{ padding: 0 }}
                        type="link"
                        onClick={() => {
                            window.location.href = "/#/activity/knowledgedetail/" + record.id
                        }}
                    >
                        详情
                    </Button>
                    <Divider type='vertical' />
                    <Button
                        style={{ padding: 0 }}
                        disabled={!record.change}
                        type="link"
                        onClick={() => {
                            window.location.href = "/#/activity/submitKnowledge/0/1/" + record.id
                        }}
                    >
                        编辑
                    </Button>
                    <Divider type='vertical' />
                    {
                        userType > 1 ? <>
                            <Button
                                style={{ padding: 0 }}
                                type="link"
                                onClick={() => {
                                    window.open("/#/activity/submitKnowledge/0/2/" + record.id)
                                }}
                            >
                                审核
                            </Button>
                            <Divider type='vertical' />
                        </> : undefined
                    }
                    {
                        userIssue ? <>
                            {
                                record.issue === 1 ?
                                    <Button
                                        style={{ padding: 0 }}
                                        disabled={record.status !== 1}
                                        type="link"
                                        onClick={() => {
                                            setComfirmShow({ ...comfirmShow, visible: true, issue: 2 });
                                            setCheckList([record.id])
                                        }}
                                    >
                                        发布
                                    </Button> :
                                    <Button
                                        style={{ padding: 0 }}
                                        type="link"
                                        danger
                                        onClick={() => {
                                            setComfirmShow({ ...comfirmShow, visible: true, issue: 1 });
                                            setCheckList([record.id])
                                        }}
                                    >
                                        回收
                                    </Button>
                            }
                            <Divider type='vertical' />
                        </> : undefined
                    }
                    <Button
                        type="link"
                        disabled={!record.change}
                        style={{ padding: 0 }}
                        danger
                        onClick={() => {
                            deleteInfo.show = true;
                            deleteInfo.list = [record.id];
                            setDeleteInfo({ ...deleteInfo })
                        }}
                    >删除</Button>
                </div>
            }
        }
    ]
    const menu = (
        <Menu onClick={({ key }) => { changeStatus(key) }}>
            <Menu.Item key={1}>回收</Menu.Item>
            <Menu.Item key={2}>发布</Menu.Item>
        </Menu>
    );
    const changeStatus = (key) => {
        setComfirmShow({ ...comfirmShow, visible: true, issue: Number(key) });
    }
    const handleIssue = () => {
        setCheckList([]);
        setFilter({ ...filter });
    }
    return (
        <div
            className='ctf-resource-list knowledge-resource-list'
            onClick={onClicks}
        >
            <div className="banner"></div>
            <div className="ctf-resource-search">
                <div className="top">
                    {
                        search.show ?
                            <div className="search-input">
                                <input
                                    className="input-fouce"
                                    type="text"
                                    placeholder="请输入关键字进行搜索"
                                    value={search.value}
                                    onKeyDown={(e) => calAge(e)}
                                    onChange={(e) => {
                                        search.value = e.target.value;
                                        setsSearch({ ...search })
                                    }}
                                />
                            </div>
                            : <div className="statistics">
                                <div>
                                    <span>{initData.resourceNumber.day}</span>
                                    <span>今日新增</span>
                                </div>
                                <div>
                                    <span>{initData.resourceNumber.month}</span>
                                    <span>本月新增</span>
                                </div>
                                <div>
                                    <span>{initData.resourceNumber.sum}</span>
                                    <span>总资源数</span>
                                </div>
                            </div>
                    }
                    <div className="search-btn" onClick={() => handelSearch()}>
                        <SearchOutlined />
                    </div>
                </div>
                <div className="bottom">
                    今天热点搜索：
                    {
                        initData.hotKeyword.map((val, key) => {
                            return <span key={"key" + key} onClick={() => {
                                filter.page = 1;
                                filter.search = val;
                                setFilter({ ...filter })
                            }}>{val}</span>
                        })
                    }
                    {
                        initData.hotKeyword.length === 0 &&
                        "暂无热搜关键字"
                    }
                </div>
            </div>
            <div className="ctf-resource-table content-container">
                <div className="handle">
                    {
                        userType > 1 ?
                            <div style={{ display: 'inline-block' }}>
                                <Button
                                    type='ghost'
                                    disabled={checkList.length === 0 ? true : false}
                                    danger
                                    onClick={() => {
                                        deleteInfo.show = true;
                                        deleteInfo.list = checkList;
                                        setDeleteInfo({ ...deleteInfo })
                                    }}
                                >
                                    批量删除
                                </Button>
                                <Divider type='vertical' />
                                {
                                    userIssue ?
                                        <Dropdown
                                            overlay={menu}
                                            disabled={checkList.length === 0}
                                        >
                                            <Button type="primary" style={{ marginLefe: '10px' }}>批量修改发布状态<DownOutlined /></Button>
                                        </Dropdown> : undefined
                                }
                            </div> : undefined
                    }
                    <Button
                        type="primary"
                        onClick={() => window.open("/#/activity/submitknowledge/0/0/0")}
                    >
                        提交知识
                    </Button>
                </div>
                <Table
                    dataSource={initData.data}
                    rowKey={record => record.id}
                    bordered
                    scroll={{ x: 1200 }}
                    rowSelection={rowSelection}
                    onChange={handleTableChange}
                    columns={columns}
                    pagination={false}
                />
                <Pagination
                    showQuickJumper={true}
                    current={filter.page}
                    pageSize={filter.size}
                    total={initData.allCount}
                    hideOnSinglePage={initData.allCount === 0}
                    pageSizeOptions={['10', '20', '50', '100']}
                    showSizeChanger={true}
                    className="flip-over"
                    style={{ margin: "30px 0" }}
                    onChange={
                        ((page, pageSize) => {
                            let data = { ...filter }
                            data.page = page;
                            data.size = pageSize;
                            setFilter(data)
                        })
                    }
                />
            </div>
            {
                deleteInfo.show &&
                <DeteleBox
                    close={() => {
                        deleteInfo.show = false;
                        deleteInfo.list = [];
                        setDeleteInfo({ ...deleteInfo })
                    }}
                    submit={() => resourceDelete(deleteInfo.list)}
                />
            }
            <Comfirm
                boxProperty={comfirmShow}
                onClose={() => {
                    setComfirmShow({ ...comfirmShow, visible: false })
                }}
                onOk={handleIssue}
                ids={checkList}
            />
        </div>
    )
}
export default List;